import { NomMassUpdateOperation } from './../../core/constants';

// ! Convention and discoverability:
// ! name of the file (post.serialize.ts, users.serialize.ts, etc. -> /post/... /user/..., etc.)
// ! name of the method in the service (assignCategoryTree) with (toUrlEncoded, toJson, toMultipartFormData, etc.)

export const assignCategoryTree = {
  toUrlEncoded(
    categories: { [key: number]: number[] },
    postIds: string[],
    updateOperation: NomMassUpdateOperation,
  ): URLSearchParams {
    const params = new URLSearchParams();

    // * Serialize nested categories as: categories[companyCategoryId][]=categoryId
    // * From: { 16030: [1731, 1729] }
    // * To:  categories[16030][]: 1731, categories[16030][]: 1729
    Object.entries(categories).forEach(([companyCategoryId, categoryIds]) => {
      categoryIds.forEach((categoryId) => {
        params.append(
          `categories[${companyCategoryId}][]`,
          categoryId.toString(),
        );
      });
    });

    postIds.forEach((postId) => {
      params.append('postIds[]', postId);
    });

    params.set('updateOperation', updateOperation.toString());

    return params;
  },

  // * toJson() {}
  // * toMultipartFormData() {}
};

export const transitionToWorkflowStage = {
  toUrlEncoded(
    workflowId: string,
    workflowStageId: number,
    feedId: string,
  ): URLSearchParams {
    const params = new URLSearchParams();

    params.append('workflowId', workflowId.toString());
    params.append('workflowStageId', workflowStageId.toString());
    params.append('queryId', feedId);

    return params;
  },
};
